export const API_BASE_URL = process.env.REACT_APP_TIMESHEET_API;

export const ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        REGISTER: '/auth/register',
        FORGOT_PASSWORD: '/auth/register',
        UPDATE_PASSWORD: '/auth/login',
    },
    TIMESHEET: {
        SUBMIT: '/submit',
        GET_ALL: '/list',
    },
    USER: {
        FETCH_USERS: '/users',
        UPDATE_USER: '/users',
        FETCH_USER_DETAILS: '/users'
    },
    MANAGER: {
        FETCH_MANAGER: '/users',
    },
    TASK: {
        FETCH_PENDING_APPROVALS: '/approvals',
        FETCH_APPROVED_TASKS: '/approvals',
        FETCH_ALL_TASKS: '/tasks',
        CREATE_TASK: '/tasks',
        UPDATE_TASK: '/tasks',
        APPROVE_TASK: '/approve',
        REVERT_TASK: '/approve'
    },
    REPORT: {
        GENERATE_REPORT: '/reports/user'
    },
    UPLOADS:{
        FILE: '/uploads/docs'
    },
    OTHERS: {
        USER_PROFILE: '/worksheet/profile',
        ADMIN_DASHBOARD: '/worksheet/dashboard'
    }
};

export const REQUEST_TYPES = {
    LOGIN: 'login',
    REGISTER: 'register',
    FORGOT_PASSWORD_MAIL: 'forgot_password_send_mail',
    UPDATE_FIRST_PW: 'update_first_login_password',
    FETCH_USERS: 'get_users_by_manager',
    UPDATE_USER: 'update_user',
    FETCH_MANAGER: 'get_manager_list',
    FETCH_EXTERNAL_MANAGER: 'get_external_manager_list',
    FETCH_PENDING_APPROVALS: 'get_pending_approvals',
    FETCH_APPROVED_TASKS: 'get_tasks_by_manager',
    APPROVE_TASK: 'approve_task',
    REVERT_TASK: 'revert_task_status',
    FETCH_USER_DETAILS: 'get_user_by_id',
    FETCH_ALL_TASKS: 'get_tasks',
    CREATE_TASK: 'create_task',
    UPDATE_TASK: 'update_task',
    GENERATE_USER_REPORT: 'generate_user_report',
    GENERATE_PROJECT_REPORT: 'generate_project_report',
    GENERATE_LEAVE_REPORT: 'generate_leave_report',
    UPLOAD_FILE: 'upload_files',
    DOWNLOAD_FILE: 'get_download_url'
};

export const MESSAGES = {
    SUCCESS:{
        LOGIN: 'User logged in successfully',
        REGISTER: 'User registered successfully',
        FORGOT_PASSWORD_MAIL: 'Send forgot password mail successfully',
        UPDATE_FIRST_PW: '"Password updated! Please login with your new password."',
        FETCH_USERS: 'Fetch users list successfully',
        UPDATE_USER: 'Update user profile successfully',
        FETCH_MANAGER: 'Fetch manager list successfully',
        FETCH_PENDING_APPROVALS: 'Fetch pending approvals successfully',
        FETCH_APPROVED_TASKS: 'Fetch approved tasks successfully',
        APPROVE_TASK: 'Approve selected task successfully',
        REVERT_TASK: 'Mark task status as pending successfully',
        FETCH_USER_DETAILS: 'Fetch user details successfully',
        FETCH_ALL_TASKS: 'Fetch all tasks successfully',
        CREATE_TASK: 'Task created successfully',
        UPDATE_TASK: 'Update task successfully',
        GENERATE_REPORT: 'Generate report successfully',
    },
    ERROR: {
        LOGIN: 'Invalid credentials',
        REGISTER: 'Failed to register user',
        FORGOT_PASSWORD_MAIL: 'Email not found. Please enter registered email',
        UPDATE_FIRST_PW: 'Failed to update first login password',
        FETCH_USERS: 'Failed to fetch users',
        UPDATE_USER: 'Failed to update user',
        FETCH_MANAGER: 'Failed to fetch managers',
        FETCH_EXTERNAL_MANAGER: 'Failed to fetch external managers',
        FETCH_PENDING_APPROVALS: 'Failed to fetch pending approvals',
        FETCH_APPROVED_TASKS: 'Failed to fetch approved tasks',
        APPROVE_TASK: 'Failed to approve task',
        REVERT_TASK: 'Failed to mark task status as pending',
        FETCH_USER_DETAILS: 'Failed to fetch user details',
        FETCH_ALL_TASKS: 'Failed to fetch all tasks',
        CREATE_TASK: 'Failed to create task',
        UPDATE_TASK: 'Failed to update task',
        GENERATE_REPORT: 'Failed to generate report',
    }
}